export default "__VITE_ASSET__9b4462aa__"